import React from "react";
import { withStyles } from "@mui/styles";

import { styles } from "./styles";
import { METRIC_TYPES } from "../../../constants/global";
import { getGeneralDate } from "../../../helpers/metrics";

const CustomTooltip = ({ tooltipData, classes, type }) => {
  const date = getGeneralDate(tooltipData.data);
  return (
    <div className={classes.wrapper}>
      <div className={classes.date}>{date.toString()}</div>
      {tooltipData.data.map((d, index) => {
        const data = Object.values(d);
        const value = type === METRIC_TYPES.CHECK_PASSED ? `${data[1]}%` : `${data[1]}ms`;
        return (
          <div className={classes.flex} key={index}>
            <span className={classes.bold} style={{ color: data[4] }}>
              {data[0]}
            </span>
            <span>{value}</span>
          </div>
        );
      })}
    </div>
  );
};

export default withStyles(styles)(CustomTooltip);
